import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import { Row, Col, List, Empty, Collapse } from 'core/components/ui'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import * as routes from 'core/routing/constants/index'
import wizardsShape from 'core/components/wizard/shapes'
import PageLoading from 'core/components/page-loading'
import { configuratorShape } from '../shapes'
import renderItem from './item'

const { Panel } = Collapse

const ContractsList = props => {
  const { configurator, setConfigurator, intl, setWizards, wizards, history } = props

  const { loading, contracts, getContracts } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const { motor, serviceContractsList } = configurator

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex =
      aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_CONTRACTS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  const renderList = () => (
    <List
      data-test="configurator-contractsList-list"
      dataSource={serviceContractsList}
      renderItem={item => renderItem({ item })}
    />
  )

  useEffect(() => {
    const runIt = list => {
      setConfigurator({
        ...configurator,
        serviceContractsList: list
      })
    }

    if (contracts) runIt(contracts)
  }, [contracts])

  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_CONTRACTS
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }
    const params = {
      id: motor.id,
      catalog: motor.catalog
    }

    getContracts(params)
    activateNextStep()
  }, [])

  return (
    <MainContentWrapper
      title={intl.formatMessage({
        id: 'configurator-contractsList-view-title'
      })}
      data-test="component-configurator-contractsList"
    >
      <Row type="flex" justify="center">
        <Col lg={16} xs={24}>
          {loading ? (
            <PageLoading data-test="configurator-contractsList-loading" />
          ) : (
            <Collapse
              defaultActiveKey={['1']}
              expandIconPosition="right"
              accordion
              bordered={false}
            >
              <Panel
                header={intl.formatMessage({
                  id: 'configurator-contractsList-title-1'
                })}
                key="1"
              >
                {serviceContractsList ? renderList() : <Empty />}
              </Panel>
            </Collapse>
          )}
        </Col>
      </Row>
    </MainContentWrapper>
  )
}

ContractsList.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  intl: PropTypes.shape().isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(injectIntl(ContractsList))
